import store from "../store";

export const userinitialState = {
    isLoggedIn: false,
    loggedInType: "",
    userData: null,
    loading: false,
    error: null,
    token: null,
    UserLoackApplications:null
};
